import { Button } from "./ui/button";
import { ChevronDown } from "lucide-react";

const HERO_BG = "https://images.pexels.com/photos/30849505/pexels-photo-30849505.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Hero() {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center hero-section"
      style={{ backgroundImage: `url(${HERO_BG})` }}
      data-testid="hero-section"
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#0B1E36]/60" />
      
      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto pt-20">
        <span 
          className="inline-block text-xs tracking-[0.2em] uppercase font-bold text-[#FACC15] mb-6 animate-fade-in-up"
          data-testid="hero-label"
        >
          Professional Boat Detailing
        </span>
        
        <h1 
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tighter mb-6 animate-fade-in-up animate-delay-100"
          style={{ fontFamily: "'Outfit', sans-serif" }}
          data-testid="hero-heading"
        >
          Deep Clean Detailers
        </h1>
        
        <p 
          className="text-lg sm:text-xl text-white/90 mb-8 animate-fade-in-up animate-delay-200"
          style={{ fontFamily: "'Manrope', sans-serif" }}
          data-testid="hero-tagline"
        >
          We Bring The Clean To You
        </p>
        
        <p 
          className="text-base text-white/70 max-w-2xl mx-auto mb-10 animate-fade-in-up animate-delay-200"
          data-testid="hero-description"
        >
          Premium mobile boat detailing services. From buffing and waxing to complete interior restoration, we make your vessel shine.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animate-delay-300">
          <Button
            onClick={() => scrollToSection("#contact")}
            className="bg-[#FACC15] text-[#0B1E36] hover:bg-[#EAB308] font-semibold px-8 py-6 text-lg rounded-none transition-all duration-300 btn-primary"
            data-testid="hero-cta-primary"
          >
            Request a Quote
          </Button>
          <Button
            onClick={() => scrollToSection("#services")}
            variant="outline"
            className="border-white text-white hover:bg-white/10 font-semibold px-8 py-6 text-lg rounded-none transition-all duration-300"
            data-testid="hero-cta-secondary"
          >
            View Services
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={() => scrollToSection("#services")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 hover:text-white transition-colors animate-bounce"
        data-testid="scroll-indicator"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
}
